import React from 'react';
import { formatLineNumbers } from '../utils/line-number';

// XPEN-3790: once the report is submitted, the invoice lines this expense became, with the
// numbers every screen shows ("Line 3", "Lines 3–4"); nothing before submission.
const ExpenseLineNumbers = ({ expense, data }) => {
    const label = formatLineNumbers(expense?.invoice_line_numbers, data.t);
    return label ? <div className="text-muted small expense-line-numbers">{label}</div> : null;
};

export default ExpenseLineNumbers;
